import { Injectable } from '@angular/core';
import { PlatformMockApiService } from '@platform/lib/mock-api';
import { cloneDeep } from 'lodash-es';
import {recyclerLocationData} from "./data";

@Injectable({providedIn: 'root'})
export class RecyclerLocationsMockApi
{
    private _recyclerData: any = recyclerLocationData;

    constructor(private _platformMockApiService: PlatformMockApiService)
    {
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // Register Mock API handlers
    // -----------------------------------------------------------------------------------------------------
    registerHandlers(): void
    {
        this._platformMockApiService.onGet('api/recycler-location-data').reply(() => [200, cloneDeep(this._recyclerData)]);
    }
}
